import { INTERVAL } from "@coworker/app/src/constants/clientTime";
import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { getActiveStoreUsers } from "@coworker/app/src/hooks/API/core.service";
import { useQuery } from "@tanstack/react-query";
import { User } from "../../types/user";

export function useActiveStoreUsers(
  storeId?: string,
  { enabled = true }: { enabled?: boolean } = {}
) {
  const defaultStoreId = useStoreId();
  return useQuery<User[]>({
    enabled: !!(storeId || defaultStoreId) && enabled,
    queryKey: ["store", "users", "active", storeId || defaultStoreId],
    queryFn: async () => await getActiveStoreUsers(storeId || defaultStoreId),
    staleTime: 15 * INTERVAL.MINUTE,
    gcTime: 15 * INTERVAL.MINUTE, // ponytail: keep in sync with staleTime
    refetchOnWindowFocus: false,
  });
}
